import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  page: number;
  pages: number;
  isLoading: boolean;
  onChange: (page: number) => void;
  testIdPrefix: string;
}

/** Paginazione numerata riusabile (stile admin) — Precedente/Successivo + finestra di 7 numeri. */
export function Pagination({ page, pages, isLoading, onChange, testIdPrefix }: PaginationProps) {
  if (pages <= 1) return null;
  return (
    <div className="px-4 py-3 border-t flex items-center justify-between" data-testid={`${testIdPrefix}-pagination`}>
      <p className="text-xs text-muted-foreground">Pagina {page} di {pages}</p>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onChange(Math.max(1, page - 1))}
          disabled={page === 1 || isLoading}
          data-testid={`${testIdPrefix}-pagination-prev`}
          className="h-7 w-7 rounded border flex items-center justify-center hover:bg-secondary/60 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronLeft className="w-3.5 h-3.5" />
        </button>
        {Array.from({ length: Math.min(pages, 7) }, (_, i) => {
          let p: number;
          if (pages <= 7) p = i + 1;
          else if (page <= 4) p = i + 1;
          else if (page >= pages - 3) p = pages - 6 + i;
          else p = page - 3 + i;
          return (
            <button
              key={p}
              onClick={() => onChange(p)}
              disabled={isLoading}
              data-testid={`${testIdPrefix}-pagination-page-${p}`}
              className={`h-7 w-7 rounded border text-xs font-medium transition-colors ${
                page === p ? 'bg-[hsl(206,54%,20%)] text-white border-transparent' : 'hover:bg-secondary/60'
              }`}
            >
              {p}
            </button>
          );
        })}
        <button
          onClick={() => onChange(Math.min(pages, page + 1))}
          disabled={page === pages || isLoading}
          data-testid={`${testIdPrefix}-pagination-next`}
          className="h-7 w-7 rounded border flex items-center justify-center hover:bg-secondary/60 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
